export default __webpack_public_path__ + "static/illustration-11th-grade-c4c682913a8bc9a2223cab72d7e8de08.svg";